module.exports = __webpack_public_path__ + "img/img4_mobile.15996ab5.png";